<div class="dialog__height" [dir]="('uiDirection' | translate)">
    <mat-dialog-content>
        <p class="font-size-s margin-bottom-base margin-top-s">
            {{ "previewFeatures.header" | translate }}
        </p>
        <!-- // Feature card  -->
        <mat-card class="card-filled background-light margin-bottom-base">
            <!-- Feature page name -->
            <h3 class="font-medium font-size-base margin-bottom-xs">{{ 'sideNav.pos' | translate }}</h3>
            <!-- Feature title and switch -->
            <div class="d-flex align-items-center justify-content-between">
                <h4 class="typo-color--primary m-0 font-size-s font-medium">
                    {{ "previewFeatures.salesOrderV2_5NewLayout" | translate }}
                </h4>
                <mat-slide-toggle id="toggle_salesOrderV2_5NewLayout" color="primary"
                    [checked]="salesOrderV2_5NewLayout" (change)="onSalesOrderV2_5NewLayoutChanged($event)"
                    *ngIf="!loading">
                </mat-slide-toggle>
                <mat-spinner id="spinner" diameter="20" *ngIf="loading"></mat-spinner>
            </div>
            <!-- Feature description -->
            <p class="mt-2 font-size-s text-description">
                {{ "previewFeatures.salesOrderV2_5NewLayoutDetails" | translate }}
            </p>

            <div class="multi-payment" [class.opacity-50]="!salesOrderV2_5NewLayout">
                <div class="d-flex align-items-center justify-content-between">
                    <h4 class="m-0 font-size-s font-medium">
                        {{ "previewFeatures.salesOrderV2_5MultiPayment" | translate }}
                    </h4>
                    <mat-slide-toggle id="toggle_salesOrderV2_5MultiPayment" [checked]="salesOrderV2_5MultiPayment"
                        (change)="onSalesOrderV2_5MultiPaymentChanged($event)" *ngIf="!loading"
                        [disabled]="!salesOrderV2_5NewLayout">
                    </mat-slide-toggle>
                    <mat-spinner id="spinner" diameter="20" *ngIf="loading"></mat-spinner>
                </div>
                <p class="mt-2 font-size-s text-description">
                    {{ "previewFeatures.salesOrderV2_5MultiPaymentDetails" | translate }}
                </p>
                <div class="mt-2 flex align-items-center gap-1" *ngIf="!salesOrderV2_5NewLayout">
                    <icon name="info" width="18" height="18"></icon>
                    <p class="mb-0 font-size-xs">
                        {{ "previewFeatures.salesOrderV2_5MultiPaymentDisableText" | translate }}
                    </p>
                </div>
            </div>
        </mat-card>
        <!-- // End feature card  -->

        <!-- // Global feature card  -->
        <mat-card class="card-filled background-light margin-bottom-base">
            <h3 class="font-medium font-size-base margin-bottom-xs">{{ 'previewFeatures.global' | translate }}</h3>
            <div class="d-flex align-items-center justify-content-between">
                <h4 class="typo-color--primary m-0 font-size-s font-medium">
                    {{ "previewFeatures.newDocumentLayout" | translate }}
                </h4>
                <mat-slide-toggle id="toggle_newDocumentLayout" color="primary"
                    [checked]="newDocumentLayout" (change)="onNewDocumentLayoutChanged($event)"
                    *ngIf="!loading">
                </mat-slide-toggle>
                <mat-spinner id="spinner_newDocumentLayout" diameter="20" *ngIf="loading"></mat-spinner>
            </div>
            <p class="mt-2 font-size-s text-description">
                {{ "previewFeatures.newDocumentLayoutDetails" | translate }}
            </p>
        </mat-card>
        <!-- // End documents feature card  -->
    </mat-dialog-content>

    @if (false) {
    <mat-dialog-content>
        <div class="text-center mb-5 mt-4">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 160" height="103" width="129">
                <g transform="translate(100, 80)">
                    <rect x="-50" y="-60" width="100" height="120" rx="5" ry="5" fill="var(--color-surface-2)"
                        stroke="var(--m3-sys-primary)" stroke-width="2.5" />
                    <rect x="-20" y="-68" width="40" height="16" rx="8" ry="8" fill="var(--m3-sys-surface)"
                        stroke="var(--m3-sys-primary)" stroke-width="2.5" />
                    <rect x="-40" y="-45" width="80" height="95" rx="3" ry="3" fill="var(--m3-sys-surface)"
                        stroke="var(--m3-sys-primary)" stroke-width="1.5" stroke-dasharray="5,3" />
                    <line x1="-30" y1="-25" x2="30" y2="-25" stroke="var(--color-surface-2)" stroke-width="4"
                        stroke-linecap="round" />
                    <line x1="-30" y1="-5" x2="30" y2="-5" stroke="var(--color-surface-2)" stroke-width="4"
                        stroke-linecap="round" />
                    <line x1="-30" y1="15" x2="30" y2="15" stroke="var(--color-surface-2)" stroke-width="4"
                        stroke-linecap="round" />
                    <line x1="-30" y1="35" x2="10" y2="35" stroke="var(--color-surface-2)" stroke-width="4"
                        stroke-linecap="round" />
                    <path d="M0,-5 L3,3 11,3 5,8 7,16 0,11 -7,16 -5,8 -11,3 -3,3 Z" fill="var(--color-surface-2)"
                        stroke="var(--m3-sys-primary)" stroke-width="2" stroke-linejoin="round" />
                    <path d="M23,-20 L24,-16 28,-15 25,-12 25,-8 22,-11 18,-9 20,-13 17,-16 21,-16 Z"
                        fill="var(--color-surface-2)" stroke="var(--m3-sys-primary)" stroke-width="1.5"
                        stroke-linejoin="round" />
                    <path d="M-23,5 L-22,9 -18,10 -21,13 -21,17 -24,14 -28,16 -26,12 -29,9 -25,9 Z"
                        fill="var(--color-surface-2)" stroke="var(--m3-sys-primary)" stroke-width="1.5"
                        stroke-linejoin="round" />
                </g>
            </svg>
            <p class="text-capitalize mt-2">
                {{ "previewFeatures.noPreviewFeaturesAvailable" | translate }}
            </p>
        </div>
    </mat-dialog-content>
    }
</div>